import React from "react";
import { View, StyleSheet, Image, TouchableHighlight} from "react-native";
import Text from "../Text";
import colors from "../../config/colors";

function NotificationListItem({
    title,
    subTitle,
    image,
    IconComponent,
    onPress,
    onPressGenerateSeed,
}) {
    return (
        <TouchableHighlight underlayColor={colors.light} onPress={onPress}>
            <View style={styles.container}>
                {IconComponent}
                {image && <Image style={styles.image} source={{ uri: image }} />}
                <View style={styles.detailsContainer}>
                    {title === 'Amigos creando' ?
                    <Text onPress={onPressGenerateSeed}
                          style={styles.titles}
                    >
                        {title}
                    </Text>
                    :
                    <Text onPress={onPressGenerateSeed}
                    style={styles.title}
                    >
                     {title}
                    </Text>
                    }
                    
                    {subTitle && (
                        <Text style={styles.subTitle} 
                              >
                            {subTitle}
                        </Text>
                    )}
                </View>
            </View>
        </TouchableHighlight>
    );
}

const styles = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        padding: 15,
        backgroundColor: colors.white,
    },
    detailsContainer: {
        marginLeft: 10,
        //justifyContent: "center",
    },
    image: {
        width: 70,
        height: 70,
        borderRadius: 35,
    },
    imageButton: {
        backgroundColor: 'yellow',
        width: 70,
        height: 70,
        borderRadius: 35,
    },
    subTitle: {
        color: colors.medium,
       // textAlign: 'center'
    },
    title: {
        fontWeight: "400",
       width: '70%'
    },
    titles: {
        fontWeight: "400",
       width: '100%'
    },
});

export default NotificationListItem;
